import(/* webpackMode: "eager" */ "/app/apps/storefront/src/app/[locale]/(modal-page)/cart/page.tsx");
